import { store } from "../store/index";
import { updateUser } from "../store/auth/actions";
import {
  selectUser,
  selectClientWallet,
  selectVerifiedRefundBankDetail,
  hasVerifiedRefundBankDetail as hasVerifiedRefundBankDetailSelector,
} from "../store/auth/selectors";

export function getAuthUser() {
  return selectUser(store.getState());
}

export function setAuthUser(user) {
  store.dispatch(updateUser(user));
}

export function getClientWallet() {
  return selectClientWallet(store.getState());
}

export function getVerifiedRefundBankDetail() {
  return selectVerifiedRefundBankDetail(store.getState());
}

export function hasVerifiedRefundBankDetail() {
  return hasVerifiedRefundBankDetailSelector(store.getState());
}
